/**
 * Fishermans — KIT DUAS ÁGUAS: dois carretéis, cada um com água + bitola.
 *
 * Raiz própria [data-fm-k2].
 *
 * POR QUE PROPERTIES E NÃO VARIANTES (ao contrário do Pesqueiro Raiz):
 * aqui TODAS as 7 bitolas da X8 300m custam R$127, então o kit é R$254 fixo —
 * não há preço pra variar. Como variantes seriam 2 águas × 7 bitolas = 14 por
 * carretel, e 14 × 14 = 196 combinações, isso encheria o admin e os feeds de
 * 196 SKUs para resolver um problema que não existe.
 *
 * E o dado do pedido sai MAIS claro: a chave da property nomeia o carretel
 * ("1º Carretel: Amazônica 0.20mm"), enquanto um título de variante
 * concatenado ("Amazônica 0.20mm / Oceânica 0.28mm") depende da ordem.
 *
 * A disponibilidade das bitolas muda entre Amazônica e Oceânica (ex.: a 0.40
 * está esgotada só na Oceânica). Por isso a lista de bitolas é remontada
 * toda vez que a água muda — e a bitola escolhida é preservada quando existe
 * na água nova.
 *
 * DOIS FORMATOS DE DADOS, porque dois kits usam este mesmo arquivo:
 *   - DUAS ÁGUAS  → `aguas` no topo: os dois carretéis são da MESMA linha (X8),
 *     então compartilham a mesma tabela de águas e bitolas.
 *   - SETUP COMPLETO → `slots`: cada carretel é uma linha DIFERENTE (X8 e X4),
 *     com preço, bitolas e disponibilidade próprios.
 * `aguasDe()` resolve os dois. Formato antigo continua valendo tal e qual.
 */
(function () {
  "use strict";

  document.querySelectorAll("[data-fm-k2]").forEach(function (root) {
    var dataEl = root.querySelector("[data-fm-k2-data]");
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!D || (!D.aguas && !D.slots)) return;

    /* tabela de águas deste carretel: própria (slots) ou compartilhada (aguas) */
    function aguasDe(carretel) {
      if (D.slots && D.slots[carretel] && D.slots[carretel].aguas) {
        return D.slots[carretel].aguas;
      }
      return D.aguas;
    }

    var estado = {};

    function montarBitolas(carretel) {
      var st = estado[carretel];
      var agua = aguasDe(carretel)[st.agua];
      var wrap = root.querySelector('[data-fm-k2-bitolas="' + carretel + '"]');
      if (!agua || !wrap) return;

      /* preserva a bitola atual se ela existir e estiver disponível nesta água */
      var manter = st.bitola && agua.bitolas.find(function (b) { return b.mm === st.bitola.mm; });
      st.bitola = manter || agua.bitolas[0];

      wrap.innerHTML = "";
      agua.bitolas.forEach(function (b) {
        var li = document.createElement("li");
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "fm-ks__box" + (b.mm === st.bitola.mm ? " is-selected" : "");
        btn.setAttribute("role", "radio");
        btn.setAttribute("aria-checked", b.mm === st.bitola.mm ? "true" : "false");
        btn.innerHTML = '<span class="fm-ks__mm">' + b.mm + '</span>' +
                        '<span class="fm-ks__lb">' + b.lb + '</span>';
        btn.addEventListener("click", function () {
          st.bitola = b;
          montarBitolas(carretel);
          render();
        });
        li.appendChild(btn);
        wrap.appendChild(li);
      });
    }

    function escolherAgua(carretel, chave) {
      if (!aguasDe(carretel)[chave]) return;
      estado[carretel].agua = chave;

      root.querySelectorAll('[data-fm-k2-agua="' + carretel + '"]').forEach(function (b) {
        var on = b.getAttribute("data-fm-k2-valor") === chave;
        b.classList.toggle("is-selected", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
      });

      montarBitolas(carretel);
      render();
    }

    function render() {
      Object.keys(estado).forEach(function (carretel) {
        var st = estado[carretel];
        var agua = aguasDe(carretel)[st.agua];
        if (!agua || !st.bitola) return;

        /*
         * DUAS PROPERTIES POR CARRETEL, de propósito:
         *
         *  - a visível leva só "Oceânica 0.32mm". É o que o cliente confere
         *    no carrinho, e código de SKU no meio disso só assusta.
         *  - a com "_" na frente leva o SKU real (ex.: OC032MM8X300M). O tema
         *    esconde qualquer property que comece com "_" no carrinho, na
         *    gaveta e na página do pedido, mas ela continua gravada no pedido
         *    e sai na API — que é por onde a separação lê.
         *
         * Escondida, verbosidade é de graça: ela leva bitola E código.
         */
        var prop = root.querySelector('[data-fm-k2-prop="' + carretel + '"]');
        if (prop) prop.value = agua.nome + " " + st.bitola.mm;

        var sku = root.querySelector('[data-fm-k2-sku="' + carretel + '"]');
        if (sku) {
          sku.value = agua.nome + " " + st.bitola.mm +
                      " (" + st.bitola.lb + ") · 300m" +
                      (st.bitola.sku ? " · " + st.bitola.sku : "");
        }

        var nome = root.querySelector('[data-fm-k2-nome="' + carretel + '"]');
        var spec = root.querySelector('[data-fm-k2-spec="' + carretel + '"]');
        var img = root.querySelector('[data-fm-k2-img="' + carretel + '"]');
        if (nome) nome.textContent = agua.titulo;
        if (spec) spec.textContent = st.bitola.mm + " (" + st.bitola.lb + ") · 300m";
        if (img && agua.imagem) { img.src = agua.imagem; img.alt = agua.titulo; }
      });

      montarItens();
    }

    /*
     * O kit entra no carrinho como AS 3 LINHAS REAIS.
     *
     * Motivo: a Bling le o SKU DA LINHA do pedido. Com o kit entrando numa
     * linha so, ela recebia "KIT-DUAS-AGUAS" e a bitola escolhida ficava em
     * line item property, que ela ignora — a expedicao nao sabia o que separar.
     * Com 3 linhas, cada uma carrega o SKU real que a Bling ja tem cadastrado.
     *
     * A property "Kit" vai em todas as 3: e o que amarra as linhas no pedido
     * e o que o carrinho usa pra travar a quantidade.
     *
     * Retrocompativel: enquanto faltar bitola escolhida ou o id do brinde, a
     * lista sai vazia e o fishermans-cart-guard cai no caminho de hoje.
     */
    function montarItens() {
      var destino = root.querySelector("[data-fm-kit-items]");
      if (!destino) return;

      /*
       * O BRINDE NAO E LINHA — vai como campo em cada linha do kit.
       *
       * Motivo: as 2 linhas somam exatamente o preco do kit (127+127 = 254).
       * Botar o copo como terceira linha levaria o total pra 381, e zerar ele
       * exigiria um desconto "compre X leve Y" que tambem daria copo pra quem
       * comprasse 2 carreteis FORA do kit — o Jorge vetou isso.
       *
       * E o brinde nunca varia: neste kit e sempre o mesmo copo. O que a
       * expedicao nao conseguia ver era a BITOLA, e essa agora vem como linha,
       * com SKU proprio.
       */
      var brinde = (D.brindeNome || "") + (D.brindeSku ? " · " + D.brindeSku : "");

      var itens = [];
      var completo = true;

      Object.keys(estado).forEach(function (carretel) {
        var st = estado[carretel];
        if (!st || !st.bitola || !st.bitola.id) { completo = false; return; }
        var agua = aguasDe(carretel)[st.agua];
        /*
         * SO O QUE IMPORTA APARECE.
         *
         * Bitola e metragem ja vem da propria variante, e o brinde agora e
         * uma LINHA — repetir os dois em property so poluia o carrinho. Fica
         * "Kit" e mais nada visivel. O resto vai com "_" na frente, que o
         * tema nao exibe, e serve pro card se montar.
         */
        var props = { "Kit": D.kitNome, "_KitHandle": D.kitHandle };
        if (brinde) props["_BrindeTxt"] = brinde;
        if (D.brindeHandle) props["_BrindeHandle"] = D.brindeHandle;
        itens.push({ id: st.bitola.id, quantity: 1, properties: props });
      });

      if (!completo) { destino.textContent = "[]"; return; }

      /*
       * BRINDE COMO LINHA DE VERDADE — so quando existir o produto de brinde
       * a R$0 (handle copo-termico-brinde-kit / c97-040-brinde-kit).
       *
       * Sem ele, D.brindeGratisId vem null e o brinde aparece apenas no card
       * do carrinho, desenhado pelo fishermans-kit-cart.js. Com ele, vira
       * linha a R$0: aparece no checkout e chega na Bling com SKU proprio,
       * sem mexer no total (R$0 nao soma).
       *
       * Nao da pra usar o produto vendido (CFP1 a R$127) porque nao existe
       * jeito de zerar preco de linha pelo /cart/add.js — so desconto, e
       * desconto nativo sempre vaza pra quem comprar os itens fora do kit.
       */
      if (D.brindeGratisId) {
        itens.push({
          id: D.brindeGratisId,
          quantity: 1,
          properties: {
            "Kit": D.kitNome,
            "Item do kit": "Brinde — " + (D.brindeNome || ""),
            "_KitHandle": D.kitHandle,
            "_Gratis": "1"
          }
        });
      }

      destino.textContent = JSON.stringify(itens);
    }

    /* Estado inicial: vem do que o Liquid marcou, nunca só do JS. */
    root.querySelectorAll("[data-fm-k2-carretel]").forEach(function (el) {
      var carretel = el.getAttribute("data-fm-k2-carretel");
      var marcado = el.querySelector('[data-fm-k2-agua].is-selected');
      var inicial = marcado ? marcado.getAttribute("data-fm-k2-valor")
                           : Object.keys(aguasDe(carretel))[0];
      estado[carretel] = { agua: inicial, bitola: null };
    });

    root.querySelectorAll("[data-fm-k2-agua]").forEach(function (b) {
      b.addEventListener("click", function () {
        escolherAgua(b.getAttribute("data-fm-k2-agua"), b.getAttribute("data-fm-k2-valor"));
      });
      b.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          escolherAgua(b.getAttribute("data-fm-k2-agua"), b.getAttribute("data-fm-k2-valor"));
        }
      });
    });

    Object.keys(estado).forEach(function (c) { montarBitolas(c); });
    render();
  });
})();
